<atom-async-data
    [ngClass]="{
        'px-5 d-block':
            partyAvatarInfoIsLoading || partyAvatarInfoHasLoadingError,
    }"
    [isLoading]="partyAvatarInfoIsLoading"
    [hasError]="partyAvatarInfoHasLoadingError"
>
    @if (avatar) {
        <div class="card border-0">
            <div class="card-body d-flex align-items-center">
                <atom-avatar
                    class="align-self-start"
                    size="xl"
                    [avatar]="avatar"
                    [editModalId]="editModalId"
                ></atom-avatar>
                @if (
                    avatar
                        | fn
                            : getAvatarInfo
                            : partyAvatarInfo
                            : navigationService
                            : entityRouteService;
                    as avatarInfo
                ) {
                    <div class="d-flex flex-column ms-4">
                        <h6>
                            @if (!avatarInfo?.routerLink) {
                                {{ avatarInfo.name }}
                            } @else {
                                <a
                                    data-cy="a-avatar-name"
                                    [routerLink]="avatarInfo?.routerLink"
                                    [queryParams]="avatarInfo?.queryParams"
                                    >{{ avatarInfo.name }}</a
                                >
                            }
                        </h6>
                        @if (avatarInfo?.status) {
                            <wdx-badge
                                [themeColor]="
                                    STATUS_THEMECOLOR_MAP[avatarInfo.status]
                                "
                            >
                                {{ avatarInfo.status }}
                            </wdx-badge>
                        }
                        @if (avatarInfo?.info) {
                            <div data-cy="lbl-avatar-job-title">
                                {{ avatarInfo.info | titleCase }}
                            </div>
                        }
                        @for (phone of avatarInfo?.phones; track $index) {
                            <a
                                [attr.data-cy]="'avartarPhone-' + phone"
                                [attr.href]="'tel:' + phone"
                            >
                                {{ phone }}
                            </a>
                        }
                        @for (email of avatarInfo?.emails; track $index) {
                            <a
                                data-cy="lbl-avatar-email"
                                [attr.href]="'mailto:' + email"
                            >
                                {{ email }}
                            </a>
                        }
                        @if (avatar.isUnknown) {
                            <div class="mt-2">
                                <button class="btn" dynamicFormId="PersonForm">
                                    Add to CLMi
                                </button>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    }
</atom-async-data>
